<template>
    <div class="create-account-step">
        <i class="fas fa-envelope"></i>
        <i class="fab fa-wpforms"></i>
        <i class="fas fa-sms"></i>
        <h3>Which communications would you like to send?</h3>
        <h5>Keep your guests informed throughout their journey</h5>
        <!--        <h5>Save time - automate</h5>-->
        <h6>
            (NOTE: The ones you select will be turned off to start.<br/>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;You can edit them and turn them on later)
        </h6>

        <div class="form-account form-create-account">

            <div v-show="loading" class="text-center">
                <h5>Loading automations</h5>
                <spinner></spinner>
            </div>

            <ValidationObserver ref="accountForm">
                <form v-show="!loading" v-on:submit.prevent="setupCommunications()">
                    <ul class="form-create-account__automations">
                        <li>
                            <div class="form-create-account__automations-event">
                                <i class="far fa-calendar-alt"></i>
                                Booking Placed
                            </div>
                        </li>

                        <li v-for="(automation) of automationsAfterBooking" v-bind:key="automation.reference">
                            <automation-summary v-bind:automation="automation"></automation-summary>
                        </li>

                        <li class="form-create-account__automations-spacer"></li>

                        <li v-for="(automation) of automationsBeforeCheckIn" v-bind:key="automation.reference">
                            <automation-summary v-bind:automation="automation"></automation-summary>
                        </li>

                        <li>
                            <div class="form-create-account__automations-event">
                                <i class="fas fa-walking automation-process-event__icon--person"></i>
                                <i class="fas fa-door-open fa-flip-horizontal"></i>
                                Check-in
                            </div>
                        </li>

                        <li v-for="(automation) of automationsAfterCheckIn" v-bind:key="automation.reference">
                            <automation-summary v-bind:automation="automation"></automation-summary>
                        </li>

                        <li class="form-create-account__automations-spacer"></li>

                        <li v-for="(automation) of automationsBeforeCheckOut" v-bind:key="automation.reference">
                            <automation-summary v-bind:automation="automation"></automation-summary>
                        </li>

                        <li>
                            <div class="form-create-account__automations-event">
                                <i class="fas fa-door-open"></i>
                                <i class="fas fa-walking automation-process-event__icon--person"></i>
                                Check-out
                            </div>
                        </li>

                        <li v-for="(automation) of automationsAfterCheckOut" v-bind:key="automation.reference">
                            <automation-summary v-bind:automation="automation"></automation-summary>
                        </li>
                    </ul>

                    <div v-show="waiting">
                        <Spinner/>
                    </div>

                    <div v-if="error" class="alert alert-danger" role="alert">
                        {{error}}
                    </div>

                    <div v-show="!loading && !waiting">
                        <button class="btn btn-primary">Finish</button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    // import dayjs from "dayjs"

    // import { store } from '@/store.js'
    import { store, mutations } from '@/store.js'
    import {ValidationObserver} from 'vee-validate'

    import {automationsMixin} from '../../mixins/AutomationsMixin'

    import AutomationSummary from './AutomationSummary';
    import Spinner from "../Spinner";

    export default {
        name: "Step4Automations.vue",
        components: {Spinner, ValidationObserver, AutomationSummary},
        mixins: [automationsMixin],
        data: function () {
            return {
                systemAutomations: [
                    // {reference: "1", name: "Registration form", type: "guest-form", when: { strategy: "immediate", numberOfDaysFrom: 0, timeOfDay: "00:00"}, selected: true},
                    // {reference: "2", name: "About your trip", type: "guest-form", when: { strategy: "before-or-after-arrival", numberOfDaysFrom: -5, timeOfDay: "10:00"}, selected: true},
                    // {reference: "3", name: "Check-in procedure", type: "email", when: { strategy: "before-or-after-arrival", numberOfDaysFrom: -1, timeOfDay: "10:00"}, selected: true},
                    // {reference: "4", name: "Reminders & contact info", type: "sms", when: { strategy: "before-or-after-arrival", numberOfDaysFrom: 0, timeOfDay: "9:00"}, selected: true},
                    // {reference: "5", name: "Welcome & check-out procedure", type: "email", when: { strategy: "before-or-after-arrival", numberOfDaysFrom: 0, timeOfDay: "20:00"}, selected: true},
                    // {reference: "6", name: "Thank you for staying with us", type: "email", when: { strategy: "before-or-after-departure", numberOfDaysFrom: 1, timeOfDay: "10:00"}, selected: true},
                ],
                automationsAfterBooking: [],
                automationsBeforeCheckIn: [],
                automationsAfterCheckIn: [],
                automationsBeforeCheckOut: [],
                automationsAfterCheckOut: [],
                loading: false,
                waiting: false,
                error: null,
            }
        },
        computed: {},
        methods: {
            getSystemAutomations: async function () {
                this.loading = true;
                try {
                    const response = await this.$http.get('/guest-management/v1/users/' + store.host.reference + '/system-templates');
                    if (response.data) {
                        this.systemAutomations.splice(0, this.systemAutomations.length);
                        this.systemAutomations.push(...response.data);
                    } else {
                        this.error = "No automations found. Please try again later."
                    }
                } catch (error) {
                    console.log(error);
                    this.error = "Error loading automations from server. Please try again later."
                } finally {
                    this.loading = false;
                }
            },
            toggleAllSystemAutomations: function () {
                this.systemAutomations.forEach((automation) => {
                    Vue.set(automation, 'selected', true);
                    if (automation.formTemplate) {
                        for (let section of automation.formTemplate.sections) {
                            for (let question of section.questions) {
                                question.selected = true;
                            }
                        }
                    }
                });
            },
            allocateAutomationsToFlows: function () {
                this.systemAutomations.forEach((automation) => {
                    this.allocateAutomationToFlow(automation);
                });
            },
            allocateAutomationToFlow: function (automation) {
                switch (automation.when.strategy) {
                    case 'immediate':
                        this.automationsAfterBooking.push(automation);
                        break;
                    case 'after-booking':
                        this.automationsAfterBooking.push(automation);
                        break;
                    case 'before-or-after-arrival':
                        if (automation.when.numberOfDaysFrom < 0 || automation.when.numberOfDaysFrom === 0 && this.isAutomationTimeOfDayLessThanHour(automation, 10)) {
                            this.automationsBeforeCheckIn.push(automation);
                        } else {
                            this.automationsAfterCheckIn.push(automation);
                        }
                        break;
                    case 'before-or-after-departure':
                        if (automation.when.numberOfDaysFrom < 0) {
                            this.automationsBeforeCheckOut.push(automation);
                        } else {
                            this.automationsAfterCheckOut.push(automation);
                        }
                        break;
                }
            },
            toggleAutomation: function (reference) {
                console.log(reference);
                for (let automation of this.systemAutomations) {
                    if (automation.reference === reference) {
                        Vue.set(automation, 'selected', !automation.selected);
                        break;
                    }
                }
            },
            setupCommunications: function () {
                this.waiting = true;
                this.error = null;
                const body = {
                    automations: []
                };

                for (let automation of this.systemAutomations) {
                    if (automation.selected) {
                        let automationToAdd = {
                            reference: automation.reference
                        };
                        if (automation.formTemplate) {
                            automationToAdd.sections = [];
                            for (const section of automation.formTemplate.sections) {
                                let sectionToAdd = { reference: section.reference, questions: [] };
                                for (const question of section.questions) {
                                    if (question.selected) {
                                        sectionToAdd.questions.push({ reference: question.reference });
                                    }
                                }
                                if (sectionToAdd.questions.length > 0) {
                                    automationToAdd.sections.push(sectionToAdd);
                                }
                            }
                        }
                        body.automations.push(automationToAdd);
                    }
                }

                this.$http.post('/guest-management/v1/users/' + store.host.reference + '/setup-automations', body
                ).then(response => {
                    this.waiting = false;
                    mutations.setHost(response.data);
                    this.$root.$emit("create-account-about-establishment");
                }).catch(error => {
                    this.waiting = false;
                    if (error.response && error.response.data.message) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                })
            }
        },
        mounted: async function () {
            await this.getSystemAutomations();
            this.toggleAllSystemAutomations();
            this.sortAllAutomations(this.systemAutomations);
            this.allocateAutomationsToFlows();
            this.$root.$on("create-account-toggle-automation", this.toggleAutomation);
        },
        beforeDestroy() {
            this.$root.$off("create-account-toggle-automation", this.toggleAutomation);
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/pages/create-account";
</style>